module.exports = __webpack_public_path__ + "media/images/soar/twitter_logo-74d0ded1948c5bcbd8255f94ba5db543.png";